// localstorage  设置,获取以及移除
import store from "store/dist/store.modern";
const storage = {
  set: function(key, value) {
    store.set(key, value);
  },
  get: function(key) {
    return store.get(key);
  },
  remove: function(key) {
    store.remove(key);
  },
  clear: function() {
    store.clearAll();
  }
};

export { storage };
